import { useMediaQuery } from '@mui/material';
import theme from '@src/styles/theme';
import RewardsEn from '@src/assets/images/leaderboard-en.png';
import RewardsVi from '@src/assets/images/leaderboad-vi.png';
import useCheckEvent from '@src/hooks/useEvent';
import Trophy from '@src/assets/images/trophy.png';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledButtonLeaderboard } from './index.style';

const ButtonLeaderboard = ({ styles }) => {
  const eventInvalid = useCheckEvent();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const history = useHistory();
  const { i18n } = useTranslation();
  const { language } = i18n;
  const isVietnamese = language === 'vi';
  if (isMobile || eventInvalid) return null;

  return (
    <StyledButtonLeaderboard
      size="small"
      color="secondary"
      onClick={() => {
        history.push(ROUTES.VOICE_LEADERBOARD);
      }}
      className="icon-btn-tooltip-refer-and-get-reward zoom-image"
      styles={styles}
    >
      <img
        src={isVietnamese ? RewardsVi : RewardsEn}
        alt="icon"
        // className="zoom-image"
        style={{ objectFit: 'cover', maxHeight: '40px', position: 'relative' }}
      />
      <img
        src={Trophy}
        alt="icon"
        style={{
          objectFit: 'cover',
          position: 'absolute',
          top: '-10px',
          left: '-10px',
          width: '40px',
          height: '40px',
        }}
      />
    </StyledButtonLeaderboard>
  );
};

export default ButtonLeaderboard;
